import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError, handleAlertBoxClick } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import UserAvatar from "../../Common/UserAvatar";
import Modal from 'react-bootstrap/Modal';
const initialFieldValues = {
    lendingApplicationId: "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    businessLegalName: "",
    businessDBA: "",
    businessPhoneNumber: "",
    businessMobilePhone: "",
    businessFax: "",
    otherPhoneNumber: "",
    website: "",
    businessEmail: "",
    physicalAddress: "",
    physicalAddressCity: "",
    physicalAddressState: "",
    physicalAddressZip: "",
    mailingAddress: "",
    mailingCity: "",
    mailingState: "",
    mailingZip: "",
    status: "SUBMITTED",
    legalEntity: "",
    businessStartDate: "",
    federalTaxID: "",
    homeBasedBusiness: "",
    openJudgements: "",
    openBankruptcies: "",
    stateOfLLC: "",
    businessDescription: "",
    industryType: "",
    businessRentInformation: "",
    monthlyRentPayment: 0,
    remainingRentTerm: "",
    paymentCurrent: "",
    landlordCompanyContact: "",
    landlordPhoneNumber: "",
    amountRequested: 0,
    fundsNeededIn: "",
    desiredFundingUse: "",
    grossAnnualSales: 0,
    grossMonthlySales: 0,
    monthlyCreditCardVolume: 0,
    currentCashAdvance: "",
    cashAdvanceLoanBalance: 0,
    creditCardCompany: "",
    accountNumber: "",
    oTitle: "Mr",
    oFirstName: "",
    oLastName: "",
    omi: "",
    oOwnership: 0,
    oHomeAddress: "",
    oCity: "",
    oState: "",
    oZip: "",
    oHomePhone: "",
    oMobileNumber: "",
    oDateOfBirth: "",
    ossn: "",
    oFicoScore: "",
    oMothersMaidenName: "",
    oPreviousAddress: "",
    cTitle: "Mr",
    cFirstName: "",
    cLastName: "",
    cmi: "",
    cOwnership: 0,
    cHomeAddress: "",
    cCity: "",
    cState: "",
    cZip: "",
    cHomePhone: "",
    cMobileNumber: "",
    cDateOfBirth: "",
    cssn: "",
    cFicoScore: "",
    cMothersMaidenName: "",
    cPreviousAddress: ""
};
export default function ClientApplications() {
    const params = useParams();
    const [values, setValues] = useState(initialFieldValues);
    const [lists, setLists] = useState([]);
    const [allData, setAllData] = useState([]);
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState("");
    const [showError, setShowError] = useState(false);
    const [clientData, setClientData] = useState('');// client number
    const [clientNumber, setClientNumber] = useState('');// client number
    const [customerNumber, setCustomerNumber] = useState('');// customer number
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');
    const [emailContent, setEmailContent] = useState('');
    const [lendingApplicationId, setLendingApplicationId] = useState("00000000-0000-0000-0000-000000000000");
    const [businessLegalName, setBusinessLegalName] = useState("");
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [showCallingModal, setShowCallingModal] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [customSubject, setCustomSubject] = useState("");
    const [callStatus, setCallStatus] = useState("Call");
    const handleOpenCallingModal = () => {
        if (clientNumber !== null) {
            setShowError(false);
            setShowCallingModal(true);
        }
        else {
            setShowError(true);
        }
    };
    const handleCloseCalling = () => setShowCallingModal(false)
    const handleOpenMessageModal = () => {
        if (clientData.smsAvailable > 0) {
            if (clientNumber !== null) {
                setShowMessageModal(true)
            }
            else {
                setShowError(true);
            }
        } else {
            handleError("InSufficient sms quota.Please recharge");
        }
    };

    const handleCloseMessageModal = () => {
        setShowMessageModal(false);
        resetForm();
    };
    const handleOpenEmailModal = () => {
        if (clientData.emailAvailable > 0) {
            setShowEmailModal(true)
        }
        else {
            handleError("InSufficient email quota.Please recharge");
        }
    };
    const handleCloseEmailModal = () => {
        setShowEmailModal(false);
        resetForm();
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETELENDINGAPPLICATION + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData();
                    }
                    else {
                        handleError(response.data.message);
                        GetData();
                    }
                });
        }
    }
    const GetClientData = () => {
            axios.get(config.APIACTIVATEURL + config.GETUSER + "?Id=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    if (response.data.data !== null) {
                        setClientData(response.data.data);
                        setClientNumber(response.data.data.plivoPhoneNumber);
                    }
                }
            });
    };
    const validateMessage = () => {
        let temp = {};
        temp.customerNumber = customerNumber === "" ? false : true;
        temp.message = message === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSendSMS = () => {
        if (validateMessage()) {
            setLoading(true);
            var formData = {
                "clientId": localStorage.getItem("clientId"),
                "toNumber": customerNumber,
                "message": message
            }
            axios.post(config.APIACTIVATEURL + config.SENDSMSTOAPPLICANT, formData, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess("Message sent successfully")
                        handleCloseMessageModal();
                        resetForm();
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                })
        }
    };
    const resetForm = () => {
        setMessage("");
        setEmailContent("");
    }
    const finalSubject = subject === "custom" ? customSubject : subject;
    const handleSendEmail = () => {
        if (!subject || (subject === "custom" && (!customSubject || !emailContent))) {
            handleError("Please fill in all required fields");
            return;
        }

        setLoading(true);
        var formData = {
            lendingApplicationId: values.lendingApplicationId,
            toEmail: values.businessEmail,
            fromEmail: "fromEmail",
            clientId: localStorage.getItem("clientId"),
            subject: finalSubject,
            message: emailContent
        };

        axios.post(config.APIACTIVATEURL + config.SENDAPPLICANTEMAIL, formData, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    handleSuccess("Email sent successfully");
                    handleCloseEmailModal();
                } else {
                    handleError(response.data.message || "Failed to send email");
                }
                setLoading(false);
            })
            .catch((error) => {
                handleError("Error sending email");
                setLoading(false);
            });
    };

    const makeCall = async () => {
        if (clientData.callAvailable > 0) {
            if (clientNumber !== null) {
                setCallStatus("Connecting...");
                setLoading(true);
                try {
                    await axios.post(config.APIACTIVATEURL + config.CLIENTCALLING, {
                        to: clientNumber,
                        receiver: customerNumber,
                        clientId: localStorage.getItem("clientId")
                    });
                    //alert('Call initiated!');
                    setCallStatus("Connected");
                    setTimeout(() => {
                        setCallStatus("Call");
                        setLoading(false);
                        setClientNumber("");
                        setShowCallingModal(false);
                        handleSuccess("Call connected successfully");
                    }, 5000);
                } catch (err) {
                    setLoading(false);
                    setCallStatus("Call");
                    if (err.response) {
                        console.error('Response error:', err.response.data);
                    } else if (err.request) {
                        console.error('No response:', err.request);
                    } else {
                        console.error('Error:', err.message);
                    }
                    alert('Failed to initiate call.');
                }
            }
            else {
                setShowError(true);
                setLoading(false);
            }
        }
        else {
            handleError("Insufficient calling quota.Please recharge");
        }
    };
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETCLIENTLENDINGAPPLICATION + "?Id=" + localStorage.getItem("clientId") + "&Status=" + status, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    var responsedata = response.data.data.data;
                    setLists(responsedata);
                    setAllData(responsedata);
                    if (responsedata !== null) {
                        if (responsedata.length > 0) {
                            setValues(responsedata[0]);
                            setCustomerNumber(responsedata[0].businessPhoneNumber);
                        }
                    }
                }
            });
    };
    const [sortBy, setSortBy] = useState('');
    const handleSortChange = (e) => {
        const sortValue = e.target.value;
        setSortBy(sortValue);

        let sortedData = [...lists];

        if (sortValue === 'name') {
            sortedData.sort((a, b) =>
                a.businessLegalName.localeCompare(b.businessLegalName)
            );
        } else if (sortValue === 'date') {
            sortedData.sort((a, b) =>
                new Date(b.createdDate) - new Date(a.createdDate)
            );
        }
        setLists(sortedData);
    };
    const handleSearch = (e) => {
        const { name, value } = e.target;
        if (value !== "") {
            setBusinessLegalName(value);
            setLists(allData.filter(app => app.businessLegalName.toLowerCase().includes(value.toLowerCase())));
        }
        else {
            setLists(allData);
            setBusinessLegalName("");
        }
    };
    const handleSearchSelect = (e, data) => {
        e.preventDefault();
        setValues(data);
        //GetListById(lendingApplication.lendingApplicationId);
        //setSearchText(lendingApplication.businessLegalName + " - " + lendingApplication.oFirstName);
        //setSearchApplicationId(lendingApplication.lendingApplicationId);
        //setAllData([]);
    }
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetData();
        GetClientData();
        if (params !== "") {
            setStatus(params.status)
        }
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="card card-body py-3">
                        <div className="row align-items-center">
                            <div className="col-12">
                                <div className="d-sm-flex align-items-center justify-space-between">
                                    <h4 className="mb-4 mb-sm-0 card-title">Applications</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card overflow-y">
                        <div className="d-flex w-100">
                            {lists.length > 0 ?
                                <div className="d-flex w-100">
                                    <div className="min-width-340">
                                        <div className="border-end">
                                            <div className="px-4 pt-9 pb-6 d-none d-lg-block">
                                                <form className="position-relative">
                                                    <div className="search-box">
                                                        <input type="text" autoComplete="off" className="form-control search" placeholder="Search for..." name="businessLegalName" onChange={handleSearch} value={businessLegalName} />
                                                        <i className="ri-search-line search-icon" />
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="app-chat">
                                                <ul className="overflow-y-auto" style={{ maxHeight: '600px' }} >
                                                    {lists.map((v, index) =>
                                                        <li key={v.lendingApplicationId} className="position-relative text-start">
                                                            <Link className={v.lendingApplicationId === lendingApplicationId ? "px-4 py-3 bg-hover-light-black d-flex align-items-center chat-user bg-light-subtle" : "px-4 py-3 bg-hover-light-black d-flex align-items-center chat-user"} onClick={(e) => handleSearchSelect(e, v)}>
                                                                <span className="position-relative">
                                                                    <UserAvatar name={v.businessLegalName} size={50} />
                                                                </span>
                                                                <div className="ms-6 d-inline-block w-75">
                                                                    <div className="d-flex">
                                                                        <h6 className="mb-1 fw-semibold chat-title">{v.businessLegalName}</h6>
                                                                    </div>
                                                                    <span className="fs-2 text-body-color d-block">{v.businessEmail}</span>
                                                                    <span className="ms-2">
                                                                        {v.status === "SUBMITTED" ?
                                                                            <span className="badge text-bg-primary fs-1 lh-1 px-2 py-1">SUBMITTED</span> :
                                                                            v.status === "APPLIED" ?
                                                                                <span className="badge text-bg-warning fs-1 lh-1 px-2 py-1 d-inline-flex flex-column align-items-center">
                                                                                    <span>PENDING APPROVAL</span>
                                                                                </span> :
                                                                                v.status === "APPROVED" ?
                                                                                    <span className="badge text-bg-success fs-1 lh-1 px-2 py-1">APPROVED</span> :
                                                                                    v.status === "REJECTED" ?
                                                                                        <span className="badge text-bg-danger fs-1 lh-1 px-2 py-1">REJECTED</span> :
                                                                                        <span className="badge text-bg-primary fs-1 lh-1 px-2 py-1">{v.status}</span>}
                                                                    </span>
                                                                </div>
                                                            </Link>
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100">
                                        <div className="w-100">
                                            <div className="">
                                                <div className="chatting-box app-email-chatting-box">
                                                    {showError === true ?
                                                        <div className="alert alert-danger bg-danger text-white alert-dismissible fade show" role="alert">
                                                            Please select marketing phone number <strong><Link className="me-2" to="/userdashboard/phonenumbers">Click here</Link></strong>
                                                        </div> : ""}
                                                    <div className="p-9 py-3 border-bottom chat-meta-user d-flex align-items-center justify-content-between">
                                                        <ul className="list-unstyled mb-0 d-flex align-items-start overflow-y-auto" style={{ maxHeight: '300px' }}>
                                                            <li className="position-relative text-center me-2" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link
                                                                    to={`/userdashboard/documents/${values.lendingApplicationId}`}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-upload-cloud-line mb-1" />
                                                                    <span className="fs-3">Documents</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Matching Lenders">
                                                                <Link to={`/userdashboard/lenders/${values.lendingApplicationId}`}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-user-search-line mb-1" />
                                                                    <span className="fs-3">Funders</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link
                                                                    to={`/userdashboard/offers/${values.lendingApplicationId}`}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-money-dollar-circle-line mb-1" />
                                                                    <span className="fs-3">Offers</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link onClick={handleOpenMessageModal}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-message-2-line  mb-1" />
                                                                    <span className="fs-3">Message</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link onClick={handleOpenEmailModal}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-mail-line mb-1" />
                                                                    <span className="fs-3">Email</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link onClick={handleOpenCallingModal}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-phone-line mb-1" />
                                                                    <span className="fs-3">Call</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link
                                                                    to={`/userdashboard/application/${values.lendingApplicationId}`}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-pencil-line mb-1" />
                                                                    <span className="fs-3">Edit</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link
                                                                    to={`/userdashboard/viewlendingapplication/${values.lendingApplicationId}`}
                                                                    className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i className="ri-eye-line mb-1" />
                                                                    <span className="fs-3">View</span>
                                                                </Link>
                                                            </li>
                                                            <li className="position-relative text-center" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Upload Documents">
                                                                <Link className="text-dark px-2 fs-3 bg-hover-primary nav-icon-hover position-relative z-index-5 d-flex flex-column align-items-center">
                                                                    <i class="ri-arrow-up-circle-fill mb-1 text-success"></i>
                                                                    <span className="fs-3">Funded</span>
                                                                </Link>
                                                            </li>
                                                        </ul>
                                                        <div className="d-flex align-items-end">
                                                            <select value={sortBy} onChange={handleSortChange} className="form-select">
                                                                <option value="">Sort By</option>
                                                                <option value="name">Name</option>
                                                                <option value="date">Date</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="position-relative overflow-y-auto" style={{maxHeight:"600px"}}>
                                                        <div className="position-relative">
                                                            <div className="chat-box email-box mh-n100 p-9">
                                                                <div className="chat-list chat active-chat">
                                                                    <div className="hstack align-items-start mb-7 pb-1 align-items-center justify-content-between">
                                                                        <div className="d-flex align-items-center gap-3">
                                                                            <UserAvatar name={values.businessLegalName} size={50} />
                                                                            <div>
                                                                                <h6 className="fw-semibold fs-4 mb-0">{values.businessLegalName} </h6>
                                                                                <p className="mb-0 fs-2">{values.status === "SUBMITTED" ? <span className="badge text-bg-primary">SUBMITTED</span> : values.status === "APPLIED" ? <span className="badge text-bg-warning">PENDING APPROVAL</span> : values.status === "APPROVED" ? <span className="badge text-bg-success">APPROVED</span> : values.status === "REJECTED" ? <span className="badge text-bg-danger">REJECTED</span> : <span className="badge text-bg-primary">{values.status}</span>}</p>
                                                                                <p className="mb-0">{values.businessEmail}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Business Email</p>
                                                                            <h6 className="fw-semibold mb-0">{values.businessEmail}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Business PhoneNumber</p>
                                                                            <h6 className="fw-semibold mb-0">{values.businessPhoneNumber}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Mobile</p>
                                                                            <h6 className="fw-semibold mb-0">{values.businessMobilePhone}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Owner Name</p>
                                                                            <h6 className="fw-semibold mb-0">
                                                                                {values.ownerName || (values.oFirstName || '') + ' ' + (values.oLastName || '')}
                                                                            </h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Home Phone</p>
                                                                            <h6 className="fw-semibold mb-0">{values.oHomePhone}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Mobile</p>
                                                                            <h6 className="fw-semibold mb-0">{values.oMobileNumber}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">CO-Owner Name</p>
                                                                            <h6 className="fw-semibold mb-0">
                                                                                {values.coOwnerName || (values.cFirstName || '') + ' ' + (values.cLastName || '')}
                                                                            </h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Home Phone</p>
                                                                            <h6 className="fw-semibold mb-0">{values.cHomePhone}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Mobile</p>
                                                                            <h6 className="fw-semibold mb-0">{values.cMobileNumber}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Legal Entity</p>
                                                                            <h6 className="fw-semibold mb-0">{values.legalEntity}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Business Start Date</p>
                                                                            <h6 className="fw-semibold mb-0">{values.businessStartDate}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Industry</p>
                                                                            <h6 className="fw-semibold mb-0">{values.industryType}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Loan Requested</p>
                                                                            <h6 className="fw-semibold mb-0">{values.amountRequested}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Gross Monthly Sales</p>
                                                                            <h6 className="fw-semibold mb-0">{values.grossMonthlySales}</h6>
                                                                        </div>
                                                                        <div className="col-4 mb-7">
                                                                            <p className="mb-1 fs-2">Gross Annual Sales</p>
                                                                            <h6 className="fw-semibold mb-0">{values.grossAnnualSales}</h6>
                                                                        </div>
                                                                        <div className="col-12 mb-7">
                                                                            <p className="mb-1 fs-2">Mailing Address</p>
                                                                            <h6 className="fw-semibold mb-0">{values.mailingAddress}, {values.mailingCity}, {values.mailingState}, {values.mailingZip}</h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                <div className="card card-body py-3">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-12">
                                            <div className="text-center text-black">No Applications found.<br></br>
                                                <Link to="/userdashboard/upload" className="btn btn-sm btn-primary mt-2">Add New Application</Link></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <Modal show={showCallingModal} onHide={handleCloseCalling}>
                    <Modal.Header>
                        <Modal.Title>Call</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="name" className="form-label">Calling Phone Number</label>
                                <input type="text" maxLength={15} value={clientNumber} name="clientNumber" onChange={(e) => setCustomerNumber(e.target.value)} className={"form-control" + applyErrorClass('clientNumber')} disabled />
                                {errors.clientNumber === false ? (<div className="validationerror">Please enter phone number </div>) : ('')}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="name" className="form-label">Client Phone Number</label>
                                <input type="text" maxLength={15} value={customerNumber} name="customerNumber" onChange={(e) => setCustomerNumber(e.target.value)} className={"form-control" + applyErrorClass('customerNumber')} placeholder="Please Enter Number" />
                                {errors.customerNumber === false ? (<div className="validationerror">Please enter phone number </div>) : ('')}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        loading === false ?
                                            <button type="submit" onClick={makeCall} className="btn btn-primary">{callStatus}</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>{callStatus}...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleCloseCalling}>Cancel</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={showEmailModal} onHide={handleCloseEmailModal}>
                    <Modal.Header>
                        <Modal.Title>Email</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="emailTo" className="form-label">To</label>
                                <input
                                    type="email"
                                    value={values.businessEmail}
                                    className="form-control"
                                    disabled
                                />
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="subject" className="form-label">Subject</label>
                                <select
                                    className="form-select mb-2"
                                    value={subject}
                                    onChange={(e) => {
                                        setSubject(e.target.value);
                                        if (e.target.value !== "custom") {
                                            setEmailContent("");
                                            setCustomSubject(""); // Reset custom subject
                                        }
                                    }}
                                    required
                                >
                                    <option value="">Select a subject</option>
                                    <option value="Documents Pending">Documents Pending</option>
                                    <option value="BankStatement Pending">BankStatement Pending</option>
                                    <option value="custom">Add Custom Subject</option>
                                </select>

                                {/* Custom subject input */}
                                {subject === "custom" && (
                                    <div className="col-lg-12 mb-3">
                                        <label className="form-label">Custom Subject</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Type your subject here"
                                            value={customSubject}
                                            onChange={(e) => setCustomSubject(e.target.value)}
                                            required
                                        />
                                    </div>
                                )}

                            </div>

                            {/* Show content textarea only for custom subjects */}
                            {subject === "custom" && (
                                <div className="col-lg-12 mb-3">
                                    <label htmlFor="emailContent" className="form-label">Email Content</label>
                                    <textarea
                                        value={emailContent}
                                        onChange={(e) => setEmailContent(e.target.value)}
                                        className="form-control"
                                        rows="5"
                                        placeholder="Enter your email content here..."
                                        required
                                    />
                                </div>
                            )}

                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        loading === false ?
                                            <button
                                                type="button"
                                                onClick={handleSendEmail}
                                                className="btn btn-primary"
                                                disabled={!subject || (subject === "custom" && (!customSubject || !emailContent))}
                                            >
                                                Send Email
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>
                                                Sending...
                                            </button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleCloseEmailModal}>
                                        Cancel
                                    </button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={showMessageModal} onHide={handleCloseMessageModal}>
                    <Modal.Header>
                        <Modal.Title>Send Message</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="name" className="form-label">Phone Number</label>
                                <input type="text" maxLength={15} value={customerNumber} name="customerNumber" onChange={(e) => setCustomerNumber(e.target.value)} className={"form-control" + applyErrorClass('customerNumber')} placeholder="Please Enter Number" />
                                {errors.customerNumber === false ? (<div className="validationerror">Please enter phone number </div>) : ('')}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="message" className="form-label">Message</label>
                                <textarea type="text" maxLength={100} value={message} name="message" onChange={(e) => setMessage(e.target.value)} className={"form-control" + applyErrorClass('message')} placeholder="Please Enter Message" />
                                {errors.message === false ? (<div className="validationerror">Please enter message </div>) : ('')}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        loading === false ?
                                            <button type="button" onClick={handleSendSMS} className="btn btn-primary">Send</button>
                                            :
                                            <button type="button" className="btn btn-primary" disabled>Sending...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={handleCloseMessageModal}>Cancel</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
}